<template>
  <div class="flex items-center justify-between">
    <span class="flex-grow flex flex-col" id="toggleLabel">
      <span class="text-sm leading-5 font-medium text-gray-700">{{ label }}</span>
      <span class="text-sm leading-normal text-gray-500">{{ description }}</span>
    </span>
    <span
      @click="toggleInput"
      role="checkbox"
      tabindex="0"
      aria-checked="false"
      aria-labelledby="toggleLabel"
      :class="textValue ? 'bg-indigo-600' : 'bg-gray-200'"
      class="ml-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline"
    >
      <span
        aria-hidden="true"
        :class="textValue ? 'translate-x-5' : 'translate-x-0'"
        class="inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"
      ></span>
    </span>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'label', 'description', 'placeholder', 'optional', 'disabled'],
  data() {
    return {
      textValue: this.modelValue,
    };
  },
  methods: {
    toggleInput() {
      this.textValue = !this.textValue;
      this.$emit('update:modelValue', this.textValue);
    },
  },
  watch: {
    modelValue(newVal) {
      this.textValue = newVal;
    },
  },
};
</script>
